import { Routes, Route } from 'react-router-dom'

import { PublicRoutes } from './'
import { ErrorBoundary, ErrorScreen } from '../components'
import Layout from '../components/Layout/Layout'
import { useUser } from '../context'

export const AppRouter = () => {
  const { loadingUser, initDone } = useUser()

  if (loadingUser || !initDone) {
    return <div>Loading...</div>
  }

  return (
    // <BrowserRouter>
    <ErrorBoundary fallback={<ErrorScreen />}>
      <Layout>
        <Routes>
          <Route path="/*" element={<PublicRoutes />} />
        </Routes>
      </Layout>
    </ErrorBoundary>
    // {/* </BrowserRouter> */}
  )
}
